import { dataFetcher } from 'core/services/requestHandler';   

export const getLibrariesPendingApprovalByStage = async (data = {}, config = {}) => {
  return dataFetcher('libraries/getLibrariesPendingApprovalByStage', data, {...config});
};

